import { createApi } from "@reduxjs/toolkit/query/react";
import type {
    ListProductUnitOptionsRequest, ListProductUnitOptionsResponse,
    ListProductsRequest, ListProductsResponse,
    ListSubBrandProductsRequest, ListSubBrandProductsResponse,
    SearchProductsRequest, SearchProductsResponse
} from "../contracts";
import { baseQueryWithAuth } from "./api";

export const productApi = createApi({
    reducerPath: "productApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listProducts: builder.query<ListProductsResponse, ListProductsRequest>({
            query: body => ({
                url: "product/list",
                method: "POST",
                body
            })
        }),
        searchProducts: builder.query<SearchProductsResponse, SearchProductsRequest>({
            query: body => ({
                url: "product/search",
                method: "POST",
                body
            })
        }),
        listSubBrandProducts: builder.query<ListSubBrandProductsResponse, ListSubBrandProductsRequest>({
            query: body => ({
                url: "product/sub-brand/list",
                method: "POST",
                body
            })
        }),
        listProductUnitOptions: builder.query<ListProductUnitOptionsResponse, ListProductUnitOptionsRequest>({
            query: body => ({
                url: "product/unit-options/list",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListProductsQuery,
    useSearchProductsQuery,
    useListSubBrandProductsQuery,
    useListProductUnitOptionsQuery,
    useLazySearchProductsQuery,
    useLazyListProductsQuery,
    useLazyListSubBrandProductsQuery
} = productApi;
